import { useMemo } from 'react';
import { flattenOverlayDataBySource } from './helpers';
import { useItemOverlays } from './useItemOverlays';
export const useOcrDataFromOverlays = ({ enabled = true, itemId }) => {
    const isEnabled = enabled && Boolean(itemId);
    const { data: itemOverlaysData, isFetching } = useItemOverlays({ enabled: isEnabled, itemId });
    const data = useMemo(() => (!isEnabled || isFetching ? {} : flattenOverlayDataBySource(itemOverlaysData)), [isEnabled, itemOverlaysData, isFetching]);
    return { data, isLoading: isFetching };
};
